/**
 * @desc 已处理信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  params: API.tms.customsClearance.yclCustomsClearance.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/customsClearance/yclExportDeclaration`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
